import React, {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaImages,
  FaArrowRight
} from "react-icons/fa";

const Gallery = () => {
  const [albums, setAlbums] =
    useState([]);

  const [open, setOpen] =
    useState(false);

  const navigate =
    useNavigate();

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/gallery/album"
    )
      .then((res) =>
        res.json()
      )
      .then((res) =>
        setAlbums(
          Array.isArray(res)
            ? res
            : []
        )
      );
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#072F5F] py-16">

        <div className="max-w-7xl mx-auto px-5 text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold text-white">

            SCHOOL GALLERY

          </h1>

          <p className="text-gray-200 text-lg mt-5">

            Explore Beautiful Memories,
            Events & School Activities

          </p>

          <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

        </div>

      </section>

      {/* GALLERY */}
      <section className="bg-[#f7f9fc] py-16 min-h-screen">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* TITLE */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Photo Albums

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              School Gallery

            </h2>

          </div>

          {/* GRID */}
          {albums.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

              {albums.map((a) => (
                <div
                  key={a.id}
                  onClick={() =>
                    navigate(
                      `/gallery/${a.id}`
                    )
                  }
                  className="group bg-white rounded-[30px] overflow-hidden shadow-lg hover:shadow-2xl border border-gray-100 cursor-pointer transition-all duration-500 hover:-translate-y-2"
                >

                  {/* IMAGE */}
                  <div className="relative h-[280px] overflow-hidden">

                    <img
                      src={
                        a.coverImage
                          ? `https://stjosephweb.ilakshyaerp.in/uploads/gallery/${a.coverImage}`
                          : "https://picsum.photos/400/300"
                      }
                      alt={a.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-all duration-700"
                    />


                    {/* NAME */}
                    <div className="absolute bottom-6 left-6 right-6">

                      <h3 className="text-3xl font-extrabold text-white leading-snug">

                        {a.name}

                      </h3>

                    </div>

                  </div>

                  {/* CONTENT */}
                  <div className="p-7 flex items-center justify-between">

                    {/* LEFT ICON */}
                    <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl group-hover:scale-110 transition-all duration-300">

                      <FaImages />

                    </div>

                    {/* BUTTON */}
                    <div className="inline-flex items-center gap-3 bg-[#0B4F9C] text-white px-6 py-3 rounded-2xl font-semibold shadow-lg group-hover:bg-[#072F5F] transition-all duration-300">

                      View Album

                      <FaArrowRight className="group-hover:translate-x-1 transition-all duration-300" />

                    </div>

                  </div>

                </div>
              ))}

            </div>
          ) : (
            <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 p-16 text-center">

              <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                <FaImages />

              </div>

              <h3 className="text-3xl font-extrabold text-[#072F5F]">

                No Albums Available

              </h3>

              <p className="text-gray-500 mt-4 text-lg">

                Gallery albums will
                appear here soon.

              </p>

            </div>
          )}

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Gallery;